import axios from 'axios';
import { API_URL } from '../config/api';

const getAuthHeaders = () => {
	const token = localStorage.getItem('authToken');
	if (!token) {
		throw new Error('No hay token de autenticacion. Por favor, inicia sesion.');
	}
	return { Authorization: `Token ${token}` };
};

export const documentalApi = {
	getTiposTramite: async () => {
		const { data } = await axios.get(`${API_URL}/api/documental/tipos-tramite/`, {
			headers: getAuthHeaders(),
		});
		return Array.isArray(data) ? data : (data?.results || []);
	},

	leerExcel: async (file) => {
		const formData = new FormData();
		formData.append('archivo', file);
		const { data } = await axios.post(
			`${API_URL}/api/documental/expedientes/leer-excel/`,
			formData,
			{
				headers: {
					...getAuthHeaders(),
					'Content-Type': 'multipart/form-data',
				},
			}
		);
		return data;
	},

	getExpedientes: async (params = {}) => {
		const { data } = await axios.get(`${API_URL}/api/documental/expedientes/`, {
			headers: getAuthHeaders(),
			params,
		});
		return Array.isArray(data) ? data : (data?.results || []);
	},

	getDocumentos: async (expedienteId) => {
		const { data } = await axios.get(
			`${API_URL}/api/documental/expedientes/${expedienteId}/documentos/`,
			{ headers: getAuthHeaders() }
		);
		return Array.isArray(data) ? data : (data?.results || []);
	},

	createExpediente: async (payload) => {
		const { data } = await axios.post(`${API_URL}/api/documental/expedientes/`, payload, {
			headers: {
				...getAuthHeaders(),
				'Content-Type': 'application/json',
			},
		});
		return data;
	},

	generarDocumentos: async (expedienteId, plantillas) => {
		const { data } = await axios.post(
			`${API_URL}/api/documental/expedientes/${expedienteId}/generar/`,
			{ plantillas },
			{
				headers: {
					...getAuthHeaders(),
					'Content-Type': 'application/json',
				},
			}
		);
		return data;
	},

	getDocumentosExpediente: async (expedienteId) => {
		const { data } = await axios.get(
			`${API_URL}/api/documental/expedientes/${expedienteId}/documentos/`,
			{ headers: getAuthHeaders() }
		);
		return Array.isArray(data) ? data : (data?.results || []);
	},

	regenerarLinkCliente: async (expedienteId) => {
		const { data } = await axios.post(
			`${API_URL}/api/documental/expedientes/${expedienteId}/regenerar-link/`,
			{},
			{
				headers: {
					...getAuthHeaders(),
					'Content-Type': 'application/json',
				},
			}
		);
		return data;
	},

	getClienteExpedienteByToken: async (token) => {
		const { data } = await axios.get(
			`${API_URL}/api/documental/expedientes/cliente/${token}/`
		);
		return data;
	},

	guardarCambiosCliente: async (token, datosCambios) => {
		const { data } = await axios.post(
			`${API_URL}/api/documental/expedientes/cliente/${token}/guardar-cambios/`,
			{ datos_cambios: datosCambios },
			{ headers: { 'Content-Type': 'application/json' } }
		);
		return data;
	},

	confirmarCambiosCliente: async (token, datosCambios) => {
		const { data } = await axios.post(
			`${API_URL}/api/documental/expedientes/cliente/${token}/confirmar/`,
			{ datos_cambios: datosCambios },
			{ headers: { 'Content-Type': 'application/json' } }
		);
		return data;
	},
};
